export const PhonePattern = '^[(]{0,1}[0-9]{3}[)]{0,1}[-\\s.]{0,1}[0-9]{3}[-\\s.]{0,1}[0-9]{4}$';
export const FaxPattern = '^[(]{0,1}[0-9]{3}[)]{0,1}[-s.]{0,1}[0-9]{3}[-s.]{0,1}[0-9]{4}$';
export const EmailPattern = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[A-Za-z]{2,5}';
export const EmailPatternWithExt = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.(education|[A-Za-z]{2,5})';
export const ZipCodePattern = '(?!00000)[0-9]{5}';
export const ZipCodePlus4Pattern = '^[0-9]{5}(?:-[0-9]{4})?$';
export const AddressRegex = '^(?=.*[a-zA-Z])[a-zA-Z0-9\\s-/.{}]*$';
